const BACKEND_MESSAGE_MAP: Record<string, string> = {
  UserNotFound: "Hare Krishna. We could not find your account. Please check your details and try again.",
  IncorrectPin: "Hare Krishna. The MPIN you entered is not correct. Please try again.",
  UserInactive: "Hare Krishna. Your account is not active yet. Please complete verification to continue.",
  AccountTemporaryBlocked:
    "Hare Krishna. Your account has been temporarily paused for protection. Please wait a little and try again.",
  Success: "Hare Krishna. Your request was completed successfully.",
  DataNotSaved: "Hare Krishna. Your details could not be saved this time. Please try again.",
  UnableToSaveChanges: "Hare Krishna. We could not save your changes right now. Please try again.",
  IncorrectOTP: "Hare Krishna. The OTP you entered is not correct. Please try again.",
  SessionTimeOut: "Hare Krishna. Your session has expired. Please log in again.",
  OTPExpired: "Hare Krishna. This OTP has expired. Please request a new one.",
  TokenNotFound: "Hare Krishna. We could not validate your session. Please log in again.",
  OTPSentSuccessfully: "Hare Krishna. Your OTP has been sent successfully.",
  DataNotFound: "Hare Krishna. We could not find the requested details.",
  UpdatedSuccessfully: "Hare Krishna. Your changes have been saved successfully.",
  ActionNotPerformed: "Hare Krishna. This action could not be completed. Please try again.",
  Ok: "Hare Krishna. Everything is in order.",
  OTPNotSent: "Hare Krishna. We could not send the OTP right now. Please try again.",
  DocumentDeletedSuccessfully: "Hare Krishna. The document has been removed successfully.",
  DocumentNotDeleted: "Hare Krishna. The document could not be removed. Please try again.",
  PleaseTryAgain: "Hare Krishna. Please try again in a moment.",
  CouponNotValid: "Hare Krishna. This coupon is not valid.",
  AlreadyRegister: "Hare Krishna. This account is already registered. Please log in instead.",
  EmailFailed: "Hare Krishna. We could not send the email right now. Please try again.",
  CouponEmailSentSuccessfully: "Hare Krishna. Your coupon email has been sent successfully.",
  EmailSentSuccessfully: "Hare Krishna. Your email has been sent successfully.",
  EmailQueuedSuccessfully: "Hare Krishna. Your email has been queued successfully.",
  EventCreatorNotRegister: "Hare Krishna. The event creator is not registered.",
  NoOffersFound: "Hare Krishna. No offers are available at the moment.",
  InvalidCouponCodeOrOfferExpired:
    "Hare Krishna. This coupon code is invalid or the offer has expired.",
  OfferExpired: "Hare Krishna. This offer has expired.",
  RegistrationEmailSendSuccessfully:
    "Hare Krishna. Your registration email has been sent successfully.",
  CouponCodeCounterMatch: "Hare Krishna. This coupon has reached its allowed usage limit.",
  ConfirmationNotSend: "Hare Krishna. The confirmation could not be sent.",
  PaymentNotSuccess: "Hare Krishna. The payment was not completed successfully.",
  MPINResetSuccessfully: "Hare Krishna. Your MPIN has been reset successfully.",
  EmailVerifiedSuccessfully: "Hare Krishna. Your email has been verified successfully.",
  PhoneVerifiedSuccessfully: "Hare Krishna. Your mobile number has been verified successfully.",
  AlreadyVerified: "Hare Krishna. This detail is already verified.",
  DataDeletedSuccessfully:
    "Hare Krishna! We will miss you. We hope to see you again on the spiritual path.",
  UserRegistered: "Hare Krishna. Your registration has been completed successfully.",
  DataNotDeleted: "Hare Krishna. Your data could not be removed. Please try again.",
};

export const isBackendMessageKey = (value: unknown): value is string => {
  if (typeof value !== "string") {
    return false;
  }

  const text = value.trim();
  if (!text) {
    return false;
  }

  return !/\s/.test(text) && /^[A-Za-z0-9_.-]+$/.test(text);
};

const humanizeBackendMessageKey = (key: string) =>
  key
    .replace(/[_.-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim();

const toSentenceCase = (value: string) => {
  const words = value
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => (/^[A-Z0-9]+$/.test(word) ? word : word.toLowerCase()));

  const sentence = words.join(" ").trim();
  if (!sentence) {
    return "";
  }

  return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};

export const getBackendMessageKey = (...candidates: Array<unknown>) => {
  for (const candidate of candidates) {
    if (isBackendMessageKey(candidate)) {
      return candidate.trim();
    }
  }

  return undefined;
};

export const resolveBackendMessage = (value: unknown) => {
  if (typeof value !== "string") {
    return undefined;
  }

  const text = value.trim();
  if (!text) {
    return undefined;
  }

  if (!isBackendMessageKey(text)) {
    return text;
  }

  const mapped = BACKEND_MESSAGE_MAP[text];
  if (mapped) {
    return mapped;
  }

  const humanized = toSentenceCase(humanizeBackendMessageKey(text));
  return humanized ? `Hare Krishna. ${humanized}.` : text;
};

export const getBackendDisplayMessage = (...candidates: Array<unknown>) => {
  for (const candidate of candidates) {
    if (typeof candidate === "string") {
      const trimmed = candidate.trim();
      if (trimmed && !isBackendMessageKey(trimmed)) {
        return trimmed;
      }
    }
  }

  const messageKey = getBackendMessageKey(...candidates);
  return messageKey ? resolveBackendMessage(messageKey) : undefined;
};
